import type { ComponentProps } from 'react';
import { Pressable } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Text from '@/components/UI/Text';

type TextVariant = ComponentProps<typeof Text>['variant'];

export default function useHeaderButton(
  onPress: () => void,
  title: string,
  disabled?: boolean,
  variant: TextVariant = 'success',
) {
  return function HeaderButton() {
    return (
      <Pressable
        disabled={disabled}
        hitSlop={20}
        onPress={onPress}
        style={({ pressed }) => [
          styles.button({ disabled }),
          pressed && !disabled ? styles.pressed : null,
        ]}
        testID="HeaderButton"
      >
        <Text variant={variant} size="lg">
          {title}
        </Text>
      </Pressable>
    );
  };
}

const styles = StyleSheet.create((theme) => ({
  button: ({ disabled }: { disabled?: boolean }) => ({
    alignItems: 'center',
    justifyContent: 'center',
    opacity: disabled ? 0.4 : 1,
    _web: {
      paddingHorizontal: theme.space('lg'),
      _hover: {
        opacity: disabled ? 0.4 : 0.8,
      },
    },
  }),
  pressed: {
    opacity: 0.8,
  },
}));
